/**
*
* RequestForm
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, Card } from 'react-bootstrap';
import { omit } from 'lodash-es';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import AlertList from 'components/AlertList/index.jsx';
import Form4 from 'components/interaction/Form4/index.jsx';
import Icon from 'components/media/Icon/index.js';
import { toUTCStrings } from 'utils/eventTimes.js';
import { isSmallScreen } from 'utils/checkMedia.js';
import messages from './messages.js';
import getSchema from './form.jsx';

const infoLink = 'https://s3-eu-west-1.amazonaws.com/static.socialschools.eu/folderverlof.pdf';

function getInitialValues(values) {
  const { start, end, handoverDocument = false, document, ...rest } = values;
  const period = start ? { start, end, allDay: true } : {};
  const defaultValues = { studentIds: [], companyInfo: {} };
  return { ...defaultValues, ...rest, period, document: { handoverDocument, document } };
}

function RequestForm(props) {
  // eslint-disable-next-line no-unused-vars
  const { values = {}, types, onHide, onSubmit } = props;
  const { connections } = useCurrentRole();
  const initialValues = getInitialValues(values);
  const [currentValues, setValues] = useState(initialValues);
  const currentSchema = getSchema(currentValues, { connections, types });

  const title = (
    <>
      <FormattedMessage {...messages.header} />
      <a href={infoLink} target="_blank" aria-label="Info"><Icon className="ms-2 ss-info" /></a>
    </>
  );

  const Component = window.socsIsInAppWebView ? Card : Modal;
  const componentProps = window.socsIsInAppWebView ? {} : { show: true, onHide, backdrop: 'static', size: 'lg' };

  async function handleSubmit(data) {
    const { period, document, reportType, employmentType, allDay, ...rest } = data;
    const body = {
      ...rest,
      ...omit(toUTCStrings(period), 'allDay'),
      ...document,
      submitted: true,
      reportType: reportType && Number(reportType),
      employmentType: employmentType && Number(employmentType),
    };
    const success = values.id ? messages.saved : messages.requested;
    await onSubmit({ body, success });
    if (onHide) {
      onHide();
    }
  }

  return (
    <Component {...componentProps}>
      <Component.Header>
        <Component.Title>{title}</Component.Title>
      </Component.Header>
      <Form4
        defaultValues={initialValues}
        schema={currentSchema}
        onCancel={onHide}
        onSubmit={handleSubmit}
        onChange={setValues}
        submitText={messages.request}
        horizontal={!isSmallScreen()}
      >
        {({ body, action }) => (
          <>
            <Component.Body>
              <AlertList />
              {body}
            </Component.Body>
            <Component.Footer>
              {action}
            </Component.Footer>
          </>
        )}
      </Form4>
    </Component>
  );
}

RequestForm.propTypes = {
  onHide: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  types: PropTypes.object,
  values: PropTypes.object,
};

export default RequestForm;
